<template>   
<el-dialog     :visible.sync="resultVisible"     :append-to-body="true"     custom-class=""     width="370px"     :close-on-click-modal="false"     :show-close="false"     :close-on-press-escape="false"   >     
<div class="result-content">       
<div         class="dialog-msg"         :class="info.status === '1' ? 'success' : 'pending'"       >         <i           class="iconfont dialog-title"           :class="info.status === '1' ? 'icon-chenggong' : 'icon-zhuyi'"         ></i>         
<div class="dialog-title">           <span v-if="info.status === '1'">加入成功</span>           <span v-if="info.status === '0'">提交成功，待审核</span>           
<div v-if="info.status === '2'" class="dialog-tips">             
<div>班级有效期
</div>             
<div>{{ info.msg || "2011-11-11 10:11 -  2022-22-22 11:11" }}
</div>           
</div>         
</div>         
<div class="dialog-info" v-if="info.status === '1'">           
<div>已加入{{ info.bookName }} {{ info.className }}！
</div>           
<div v-if="info.joinShelf">{{ info.bookName }}已为您自动加入书架
</div>         
</div>         
<div class="dialog-info" v-if="info.status === '0'">           
<div>已申请加入{{ info.bookName }} {{ info.className }}！
</div>           
<div>             <span>请等待老师审核！</span>             <span v-if="info.joinShelf">{{ info.bookName }}已为您自动加入书架</span>           
</div>         
</div>       
</div>       <span class="dialog-footer">         
<el-button autoId="btn_openBook"           v-if="info.status === '1' && !fromBookPreview"           type="primary"           @click="openBook"           >打开教材 
</el-button         >         
<el-button autoId="btn_cancel"           v-if="['0', '2'].includes(info.status)"           type="primary"           @click="cancel"           >好的 
</el-button         >         
<el-button autoId="btn_cancel" v-if="info.status === '1'" type="text" @click="cancel"           >关闭页面 
</el-button         >       </span>     
</div>   
</el-dialog> </template>

<script>
import { mapGetters } from 'vuex'

/** 加入班级结果 */
export default {
  props: {
    result: {
      type: String || Boolean,
      default: "",
    },
    fromBookPreview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      resultVisible: false,
      info: {},
    };
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    open(data) {
      this.info = data;
      this.resultVisible = true;
    },
    /** 打开教材 */
    openBook() {
      if (this.info.collegeName !== this.userInfo.collegeName) {
        this.$message.warning(`请切换至${this.info.collegeName}后使用。`);
        return;
      }
      this.$emit("open", this.info);
      this.resultVisible = false;
    },
    /** 关闭页面 */
    cancel() {
      this.resultVisible = false;
      this.$emit("cancel");
    },
  },
};
</script>

<style lang="scss" scoped>
.result-content {
  padding: 48px 40px;
}
.dialog-msg {
  display: flex;
  flex-direction: column;
  align-items: center;
  i {
    font-size: 40px;
  }
  div.dialog-title {
    font-size: 16px;
    font-weight: 500;
    margin: 10px 0;
    .dialog-tips {
      text-align: center;
    }
  }
  .dialog-info {
    color: #b9becc;
    text-align: center;
    font-size: 12px;
  }
}
.success {
  .dialog-title {
    color: #70bd0f;
  }
}
.pending {
  .dialog-title {
    color: #faa501;
  }
}
.dialog-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
}
:deep(.el-dialog__header) {
  padding: 0;
}
:deep(.el-dialog__body) {
  padding: 0;
}
:deep(.el-dialog) {
  overflow: hidden;
}
.el-button + .el-button {
  margin-left: 0;
}
</style>
